import React, { Component } from 'react';
import { connect } from 'react-redux';

import { receiveError } from '../../../store/actions/notificationAction';

import pickupOrderRemote from '../../../api/pickupOrderRemote';

import OtherChecks from './OtherChecks';

import ApiResponse from '../../../models/ApiResponse';
import ResponseError from '../../../models/ResponseError';
import OtherChecksModel from '../../../models/OtherChecks';
import { OtherChecksForm, Value }  from '../../../models/OtherChecksForm';

interface OtherChecksContainerProps {
  doNumber: string;
  awbCode: string;
  awbNumber: string;
  awbVer: number;
  receiveError: Function;
  checkElement: (check: boolean) => JSX.Element;
  setStatusOther: (statusOther: boolean) => void;
  onlyRead?: boolean;
  deliveredDate: string;
};

interface OtherChecksContainerState {
  otherChecks: OtherChecksModel;
  ver: number;
  doNumber: string;
  awbCode: string;
  awbNumber: string;
  awbVer: number;
  verFlight?: number;
};

interface Data {
  r4c_form_ver: number,
  r4c_form_data: Array<Value>,
  r4c_form_ver_flight?: number
};

class OtherChecksContainer extends Component<OtherChecksContainerProps, OtherChecksContainerState> {

  state = {
    otherChecks: {
      r4c_form_data: {
        r4c_form_ver: -1,
        r4c_form_data: [],
        r4c_form_green: [],
        r4c_form_ver_flight: -1
      },
      r4c_form_green: false,
      r4c_form_ver: -1,
      r4c_form_ver_flight: -1,
      r4c_form: []
    },
    ver: -1,
    awbVer: -1,
    doNumber: '',
    awbCode: '',
    awbNumber: ''
  };

  componentDidMount() {

    const doNumber: string = this.props.doNumber;
    const awbCode: string = this.props.awbCode;
    const awbNumber: string = this.props.awbNumber;
    const awbVer: number = this.props.awbVer;

    if (doNumber && awbCode && awbNumber) {
      
      this.setState({ doNumber, awbCode, awbNumber, awbVer });
      this.loadOrPostData('load', doNumber, awbCode, awbNumber, awbVer);
    }
  }

  componentDidUpdate(prevProps: OtherChecksContainerProps) {

    const doNumber: string = this.props.doNumber;
    const awbCode: string = this.props.awbCode;
    const awbNumber: string = this.props.awbNumber;
    const awbVer: number = this.props.awbVer;
    if (prevProps.doNumber !== doNumber && prevProps.awbNumber !== awbNumber) {

      this.setState({ doNumber, awbCode, awbNumber, awbVer });
      this.loadOrPostData('load', doNumber, awbCode, awbNumber, awbVer);
    }
  }

  loadOrPostData = (type: string, doNumber: string, code: string, number: string, ver: number, form?: Array<Value>, flightVer?: number): void => {

    let data: Data = {
      r4c_form_ver :-1,
      r4c_form_data : [],
      r4c_form_ver_flight: -1,
    };

    if (form) {
      data = {
        r4c_form_ver : this.state.ver,
        r4c_form_data : form,
        r4c_form_ver_flight: flightVer ? flightVer : -1
      };
    }

    const result: Promise<ApiResponse<OtherChecksModel>> =
      (type === 'load') ? pickupOrderRemote.getGhaPoAwbOtherChecks(doNumber, code, number, ver) : pickupOrderRemote.updateGhaPoAwbOtherChecks(doNumber, code, number, ver, data);

    result.then((resp: ApiResponse<OtherChecksModel>) => {

      const result: OtherChecksModel | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (result) {

        const otherStatus: boolean = result.r4c_form_green;
        this.props.setStatusOther(otherStatus);
        let otherChecks: OtherChecksModel = { ...result };

        if (!otherChecks.r4c_form_data) {

          const length: number = otherChecks.r4c_form.length;
          const r4c_form_ver: number = otherChecks.r4c_form_ver;
          const r4c_form_data: Array<Value> = [];

          otherChecks.r4c_form.map((val: OtherChecksForm)  => {
            r4c_form_data.push(val.default_value)
            }
          );
          const r4c_form_green: Array<boolean> = Array(length).fill(false);

          otherChecks.r4c_form_data = {
            r4c_form_ver,
            r4c_form_data,
            r4c_form_green
          };
        }

        this.setState({ otherChecks, ver: otherChecks.r4c_form_ver });
      }

      if (error) {
        this.props.receiveError(error);
      }
    });
  }

  handleChange = (event: any): void => {

    const value: Value = event.target.value;
    const id: number = +event.target.id
    const formData: any= [ ...this.state.otherChecks.r4c_form_data.r4c_form_data ]
    formData[id] = value;
    
    const otherChecks: OtherChecksModel = { ...this.state.otherChecks }

    console.log('🚀 ~ OtherChecksContainer ~ otherChecks:', otherChecks)
    otherChecks.r4c_form_data.r4c_form_data = formData;

    this.setState({ otherChecks })

    this.loadOrPostData('post', this.state.doNumber, this.state.awbCode, this.state.awbNumber, this.state.awbVer, formData, otherChecks.r4c_form_ver_flight);

  };
 
  render() {

    return (
      <OtherChecks
        otherChecks={ this.state.otherChecks }
        handleChange={ this.handleChange }
        checkElement={ this.props.checkElement }
        awbCode={ this.state.awbCode }
        onlyRead={ this.props.onlyRead }
        deliveredDate={ this.props.deliveredDate }
      />
    );
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error))
  };
}

export default connect(null, mapDispatchToProps)(OtherChecksContainer);